import { addDays, addMonths, endOfMonth, format, getISODay, parseISO, startOfMonth, } from 'date-fns';
const DAY_FORMAT = 'yyyy-MM-dd';
const MONTH_FORMAT = 'yyyy-MM';
export const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const STREAK_BADGES = [
    { days: 10, emoji: '🏃‍♀️' },
    { days: 20, emoji: '🏃‍♂️' },
    { days: 50, emoji: '🥳' },
    { days: 100, emoji: '❤️' },
    { days: 500, emoji: '👏' },
    { days: 1000, emoji: '🦾' },
];
export const toDayString = (date) => format(date, DAY_FORMAT);
export const toMonthString = (date) => format(date, MONTH_FORMAT);
// "2026-11" -> Date at local midnight on the 1st, no timezone conversion
const parseMonth = (month) => parseISO(`${month}-01`);
export const shiftMonth = (month, amount) => toMonthString(addMonths(parseMonth(month), amount));
export const formatMonthTitle = (month) => format(parseMonth(month), 'MMMM yyyy');
export const formatStreakDate = (day) => format(parseISO(day), 'd MMM yyyy');
// Avoids Number.toLocaleString, which is unreliable on device (see formatAmount)
export const formatCount = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export const dayWord = (count) => (count === 1 ? 'day' : 'days');
export const getCalendarDayState = (day, { month, today, activeDays }) => {
    // Days of the adjacent months show the streak too, when they are loaded
    if (day < today && activeDays.has(day))
        return 'active';
    if (!day.startsWith(month))
        return 'outside';
    if (day === today)
        return 'today';
    return 'inactive';
};
// Whether the user opened the app that day, so a streak runs through it.
// Unlike getCalendarDayState, this also covers days of the adjacent months
export const isStreakDay = (day, { today, activeDays }) => day === today || (day < today && activeDays.has(day));
export const shiftDay = (day, amount) => toDayString(addDays(parseISO(day), amount));
// Weeks of the month, Monday first, padded with days of the adjacent months
export const buildCalendarWeeks = (params) => {
    const first = parseMonth(params.month);
    const start = addDays(first, 1 - getISODay(first));
    const last = endOfMonth(first);
    const end = addDays(last, 7 - getISODay(last));
    const weeks = [];
    for (let date = start; date <= end; date = addDays(date, 1)) {
        if (getISODay(date) === 1)
            weeks.push([]);
        const day = toDayString(date);
        weeks[weeks.length - 1].push({
            date: day,
            dayOfMonth: date.getDate(),
            state: getCalendarDayState(day, params),
        });
    }
    return weeks;
};
export const getStreakBadges = (longestStreakDays) => STREAK_BADGES.map((badge) => ({
    ...badge,
    isUnlocked: longestStreakDays >= badge.days,
}));
export const isMonthBefore = (month, day) => month < toMonthString(startOfMonth(parseISO(day)));
